import React, {useState, useEffect, Fragment} from 'react';
import firebase from './firebase';
import isNil from 'lodash/isNil';

import {
  BrowserRouter as Router,
  Switch,
  Route, Link
} from "react-router-dom";

import PrivateRoute from "./common/PrivateRoute";
import Login from "./login/Landing";
import { Profile } from "./profile/Profile";
import { ProfileEdit } from "./profile/ProfileEdit";

import './App.css';
import { User } from 'firebase';
import Inbox from './inbox/Inbox';
import { ProductEdit } from './vendor/product/ProductEdit';
import { SignUp } from './profile/SignUp';
import { Search } from './buyer/search/Search';

const db = firebase.firestore();

const App = () => {
  const [user, setUser] = useState<User | null>(null);
  const [profile, setProfile] = useState<firebase.firestore.DocumentData>({});

  console.log('Rendering app', user, profile);

  useEffect(() => {
    return firebase.auth().onAuthStateChanged((user) => {
      setUser(user);
    });
  }, []);

  useEffect(() => {
    if (user) {
      const profileDoc = db.collection("profiles").doc(user.uid);

      // listen for document changes
      profileDoc.onSnapshot(docSnaphot => {
        const docData = docSnaphot.data();
        if (!isNil(docData)) {
          setProfile(docData);
        }
      });

      // unregister document listner
      return () => profileDoc.onSnapshot(() => {})();
    }
  }, [user]);

  return (
    <div>
      <Router>
        <div className='header-container'>
          {user &&
            <div className='header'>
              <button className='button header-nav' style={{float: 'right'}} onClick={() => firebase.auth().signOut()}>
                Log Out
              </button>
              <Link to="/inbox" style={{float: 'right'}}>
                <button className='button header-nav'>Inbox</button>
              </Link>
              <Link to="/" style={{float: 'right'}}>
                <button className='button header-nav'>Home</button>
              </Link>
            </div>
          }
        </div>

        <Fragment>
          <Switch>
            <Route path="/signup">
              <div className='main'><SignUp /></div>
            </Route>
            <Route path="/login">
              <div className='main'><Login user={user} /></div>
            </Route>
            <PrivateRoute user={user} path="/inbox">
                { user && <Inbox user={user} /> }
            </PrivateRoute>
            <PrivateRoute user={user} path="/products/edit/:id">
              <div className='main'>
              { // we know user is not null at this point
                // but how to tell typescript...?
                <ProductEdit user={user} />
              }
              </div>
            </PrivateRoute>
            <PrivateRoute user={user} path="/products/edit">
              <div className='main'>
              { user && <ProductEdit user={user} /> }
              </div>
            </PrivateRoute>
            <PrivateRoute user={user} path="/edit">
              <div className='main'>
              { user && <ProfileEdit user={user} profile={profile} /> }
              </div>
            </PrivateRoute>
            <PrivateRoute user={user} path="/">
              <div className='main'>
              { user && profile.type === 'vendor' && <Profile user={user} profile={profile} /> }
              { user && profile.type === 'buyer' && <Search user={user} profile={profile} /> }
              </div>
            </PrivateRoute>
          </Switch>
        </Fragment>
      </Router>
    </div>
  );
};

export default App;
